class MarcasSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.marcas__track');
    this.dots = this.querySelectorAll('.marcas__dot');
    this.items = this.querySelectorAll('.marcas__item:not(.marcas__item--clone)');

    if (!this.track) return;

    this.initDrag();
    this.updateDots();
    this.track.addEventListener('scroll', () => this.updateDots(), { passive: true });
  }

  initDrag() {
    let startX = 0;
    let scrollStart = 0;
    let isDragging = false;

    this.track.addEventListener('pointerdown', (e) => {
      isDragging = true;
      startX = e.clientX;
      scrollStart = this.track.scrollLeft;
      this.track.classList.add('marcas__track--dragging');
      this.track.setPointerCapture(e.pointerId);
    });

    this.track.addEventListener('pointermove', (e) => {
      if (!isDragging) return;
      const dx = e.clientX - startX;
      this.track.scrollLeft = scrollStart - dx;
    });

    this.track.addEventListener('pointerup', () => {
      isDragging = false;
      this.track.classList.remove('marcas__track--dragging');
    });

    this.track.addEventListener('pointercancel', () => {
      isDragging = false;
      this.track.classList.remove('marcas__track--dragging');
    });

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.scrollToItem(i));
    });
  }

  scrollToItem(index) {
    const items = [...this.querySelectorAll('.marcas__item:not(.marcas__item--clone)')];
    if (!items[index]) return;
    items[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  updateDots() {
    const items = [...this.querySelectorAll('.marcas__item:not(.marcas__item--clone)')];
    const trackRect = this.track.getBoundingClientRect();
    let activeIndex = 0;
    let minDist = Infinity;

    items.forEach((item, i) => {
      const rect = item.getBoundingClientRect();
      const dist = Math.abs(rect.left + rect.width / 2 - (trackRect.left + trackRect.width / 2));
      if (dist < minDist) { minDist = dist; activeIndex = i; }
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('marcas__dot--active', i === activeIndex);
    });
  }
}

customElements.define('marcas-slider', MarcasSlider);
